/**
 * Validates that all amount values are positive, otherwise it throws an error.
 */
export const validateAmounts = (amounts: number[]): void => {
  const hasNegativeAmounts = amounts.some((value: number) => value < 0);

  if (hasNegativeAmounts) {
    throw new Error("All amount values should be positive");
  }
};
